/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import ApexCharts from 'apexcharts';
import { chartOptions } from '../consts';

export function InteractionsGraph({ data }) {
	const id = 'interactions-graph';

	useEffect(() => {
		const element = document.getElementById(id);

		if (!element) {
			return;
		}
		const options = getChartOption(data);
		const chart = new ApexCharts(element, options);
		chart.render();

		return function cleanUp() {
			chart.destroy();
		};
	}, [data]);

	return <div id={id}></div>;
}

function getChartOption(data) {
	const interactionsData = data.map((d) => {
		return {
			...d.metrics.Interactions, ts: d.ts
		}
	})
	const preOptions = chartOptions(interactionsData);
	preOptions.yaxis = {
		...preOptions.yaxis,
		labels: {
			formatter: (v) => parseInt(v),
		},
	};
	
	const options = {
		series: [
			{
				name: 'Likes',
				data: interactionsData.map((d) => d.like || 0),
			},
			{
				name: 'Wishlist',
				data: interactionsData.map((d) => d.wishlists || 0),
			},
			{
				name: 'Comments',
				data: interactionsData.map((d) => d.comment || 0),
			},
			{
				name: 'Votes',
				data: interactionsData.map((d) => d.vote || 0),
			},
		],
		colors: ['#835FC2', '#D55DB1', '#FE6F5E', '#FFC75F'],
		...preOptions,
	};
	return options;
}
